<template>
  <div>
    <!-- empty div required for root dialog component -->
    <b-modal ref="modal" size="sm" centered>
      <form ref="form" @submit="submit">
        <fields
          :fields="fields.all()"
          :model="model"
          :errors="errors"
          layout="vertical"
        />
      </form>
    </b-modal>
  </div>
</template>

<script>
import { FormMixin } from 'stylemix-base'
import CompaniesApi from './Api'

export default {
  name: 'EmailMessage',

  mixins: [FormMixin],

  props: {
    companyId: {
      type: [Number, String],
      required: false,
    },
    customerEmail: {
      type: [String],
      required: false,
    },
    driverEmail: {
      type: [String],
      required: false,
    },
  },

  data() {
    return {
      model: {
        message: '',
      },
    }
  },

  mounted() {
    const modal = this.$refs.modal

    modal.show()

    modal.$on('shown', () => {
      this.setFields([
        {
          attribute: 'message',
          label: this.$t('companies.message_text'),
          component: 'textarea-field',
        },
      ])
    })

    modal.$on('close', () => {
      this.$close()
    })

    modal.$on('ok', event => {
      event.preventDefault()
      this.submit()
    })

    modal.$on('cancel', () => {
      this.$close()
    })
  },

  methods: {
    submit() {
      let mail = new CompaniesApi();
      if(this.companyId)
        mail = mail.sendCompanyMail(this.companyId, this.model)
      else if (this.driverEmail)
        mail = mail.sendMail(this.driverEmail, this.model, 'driver')
      else
        mail = mail.sendMail(this.customerEmail, this.model, 'user')
      return this.$uiBlocker(
         mail.then(result => {
           this.$refs.modal.hide()
           this.$close(this.model)
           this.$toast.success(result.message)
         })
         .catch(error => {
           if (error.status === 422) {
             this.setValidationErrors(error.data.errors)
           }
           return Promise.reject(error)
         }),
        this.$refs.modal.$refs.content,
      )
    },
  },
}
</script>
